import { useSearchParams } from "react-router-dom";
import { useFilters } from "../../../providers/filters";

const NoDoctors = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const { resetFilters, setSearchInputValue } = useFilters();

  return (
    <div className="py-5 my-4 text-center no-doctors" role="status">
      <div className="no-doctors-icon" aria-hidden="true">
        <i className="las la-user-md"></i>
      </div>
      <h3 className="h4 mb-2">Nenhum profissional encontrado</h3>
      <p className="text-muted mb-4">
        Tente buscar por outro nome, especialidade ou convênio
        {Array.from(searchParams).length > 0 && " — ou limpe os filtros para ver todos os profissionais"}.
      </p>
      {Array.from(searchParams).length > 0 && (
        <button
          onClick={() => {
            setSearchInputValue("");
            resetFilters();
            setSearchParams({});
          }}
          className="btn btn-outline-danger"
        >
          <i className="las la-times me-2" aria-hidden="true"></i>
          <span>Limpar Filtros</span>
        </button>
      )}
    </div>
  );
};

export { NoDoctors };
